import { IInspectionItem } from 'app/shared/model/inspection-item.model';
import { IInspectionHistory } from 'app/shared/model/inspection-history.model';

export interface IInspectionItemPerformed {
  id?: number;
  satisfied?: boolean | null;
  observations?: string | null;
  imageContentType?: string | null;
  image?: string | null;
  inspectionItem?: IInspectionItem | null;
  inspectionHistory?: IInspectionHistory | null;
}

export const defaultValue: Readonly<IInspectionItemPerformed> = {
  satisfied: false,
};
